module.exports = __webpack_public_path__ + "img/asus-zenfone-live-l2.2fabb2ef.jpg";